import * as helpers from 'src/services/api/common/ws/svelte/helpers';
import { api } from 'src/services/api/reallis';
// region helpers
export function getResponseValue(response) {
    return response.result.response.value;
}
function getApi(auth) {
    return auth
        ? api.ws.ws1
        : api.ws.ws1.api;
}
function createResponsePredicate({ method, }) {
    return function responsePredicate(responseData, responseRequestId) {
        var _a, _b;
        return ((_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.result) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.method) === method;
    };
}
function createRequestFactory({ requestTemplate, }) {
    return function createRequest(data) {
        return Object.assign(Object.assign({}, requestTemplate), { params: data || {} });
    };
}
function getResponseValueFactory({ getResult, }) {
    return function _getResponseValue(response) {
        const value = getResponseValue(response);
        if (getResult) {
            return getResult(value);
        }
        return value;
    };
}
// endregion
// region createWebSocketStore
export function createWebSocketStore({ auth, requestTemplate, getResult, }) {
    return helpers.createWebSocketStore({
        api: getApi(auth),
        createRequest: createRequestFactory({
            requestTemplate,
        }),
        getResponseValue: getResponseValueFactory({ getResult }),
        responsePredicate: createResponsePredicate({
            method: requestTemplate.method,
        }),
    });
}
// endregion
